import humps from 'humps'
import http from '@/config/http'

const root = process.env.VUE_APP_API_URL
const pmode = process.env.VUE_APP_PMODE
const time = () => new Date().getTime()

export default {
  call: {
    list: async (contacts) =>
      http.get('call/call-c.php5', {
        params: {
          fn: 'calls',
          contacts: JSON.stringify(contacts),
          pmode,
          _: time(),
        },
      }),
  },
  country: {
    list: async () =>
      http.get('country/country-c.php5', {
        params: {fn: 'countries', pmode, _: time()},
      }),
  },
  event: {
    token: {
      generate: async (event_id, tac_id, exp_date) =>
        http.post('event/event-c.php5', {
          fn: 'generate_token',
          event_id,
          tac_id,
          exp_date,
          pmode,
          _: time(),
        }),
      decode: async (event_id, token) =>
        http.get('event/event-c.php5', {
          params: {
            fn: 'decode_token',
            event_id,
            token,
            pmode,
            _: time(),
          },
        }),
    },
  },
  nda: {
    get: (soldto_id, event_id) => {
      return http.get('nda/nda-c.php5', {
        params: {
          fn: 'nda',
          soldto_id,
          event_id,
          pmode,
          _: time(),
        },
      })
    },
    templates: () => {
      return http.get('nda/nda-c.php5', {
        params: {
          fn: 'ndas',
          pmode,
          _: time(),
        },
      })
    },
    dashboard: () => {
      return http.get('nda/nda-c.php5', {
        params: {fn: 'dashboard', pmode, _: time()},
      })
    },
    template: (id) => {
      return `${process.env.VUE_APP_API_URL}/nda/download-template.php5?pmode=${pmode}&template_id=${id}`
    },
    file: (tid, sid) => {
      return `${process.env.VUE_APP_API_URL}/nda/download-nda.php5?pmode=${pmode}&template_id=${tid}&soldto_id=${sid}`
    },
    list:  (q = {}) => {
        return http.get('nda/nda-c.php5', {
          params: {
              fn: 'dashboard_ndas',
              soldto_id: q.soldto_id,
              soldto_name: q.soldto_name,
              start_date_from: q.start_date_from,
              start_date_to: q.start_date_to,
              statuses: q.statuses,
              pmode,
            _: time()
          }
        });
    }
  },
  request: {
    get: async (f = {}) => {
      if (f.request_id) {
        return http.get('request/request-c.php5', {
          params: {
            fn: 'request',
            request_id: f.request_id,
            pmode,
            _: time(),
          },
        })
      }
      if (f.webkey_id && f.event_id) {
        return http.get('request/request-c.php5', {
          params: {
            fn: 'request',
            webkey_id: f.webkey_id,
            event_id: f.event_id,
            pmode,
            _: time(),
          },
        })
      }
      return new Promise((_, reject) => {
        reject(new Error('Invalid arguments.'))
      })
    },
    list: (f = {}) => {
      if (f.webkey_id) {
        return http.get('request/request-c.php5', {
          params: {
            fn: 'requests',
            webkey_id: f.webkey_id,
            pmode,
            _: time(),
          },
        })
      }
      return http.get('request/request-c.php5', {
        params: {fn: 'requests', pmode, _: time()},
      })
    },
    create: async (pl) => {
      pl.fn = 'create_request'
      pl.pmode = pmode
      pl._ = time()

      return http.post('request/request-c.php5', humps.decamelizeKeys(pl))
    },
    update: async (pl) => {
      pl.fn = 'update_request'
      pl.pmode = pmode
      pl._ = time()

      return http.post('request/request-c.php5', humps.decamelizeKeys(pl))
    },
    csv: (event_id) => `${root}request/reports/build-report.php5?event_id=${event_id}`,
  },
  soldto: {
    get: async (sid) =>
      http.get('soldto/soldto-c.php5', {
        params: {fn: 'soldto', soldto_id: sid, pmode, _: time()},
      }),
  },
  ssp: {
    requests: async (context) =>
      http.post('request/ssp.php5', {
        fn: 'db_requests',
        context: humps.decamelizeKeys(context),
        pmode,
        _: time(),
      }),
  },
  test: {
    list: async () =>
      http.get('test/test-c.php5', {
        params: {fn: 'tests', pmode, _: time()},
      }),
  },
  tester: {
    // eslint-disable-next-line consistent-return
    list: (f = {}) => {
      if (f.webkey_id) {
        // todo
      } else {
        return http.get('registrant/registrant-c.php5', {
          params: {fn: 'registrants', pmode, _: time()},
        })
      }
    },
  },
  webkey: {
    get: async () =>
      http.get('webkey/webkey-c.php5', {
        params: {fn: 'webkey_acct', pmode, _: time()},
      }),
  },
}
